<template>
<div class="chapter">
<div class="inner_page">
<div id="fm05">
<p class="dedication"><em class="italic">For the Memory of My Mother</em></p>
<p class="dedication1"><em class="italic">and of Olga</em></p>
<p class="dedication1"><em class="italic">and of Beverle Houston</em></p>
<p class="dedication2"><em class="italic">And for Michael Earl Snyder</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?5bf42b93